import { ArrowLeft, ArrowRight, Trash2 } from 'lucide-react';
import { Button } from '@/shared/components';
import { ResourceImageThumb } from './ResourceImageThumb';

interface Props {
  groupId: string;
  resourceId: string;
  imageId: string;
  /** 1-basiert, für die Beschriftung („Foto 2 entfernen“). */
  number: number;
  first: boolean;
  last: boolean;
  busy: boolean;
  onMove: (direction: 'Up' | 'Down') => void;
  onRemove: () => void;
}

/**
 * Ein Foto mit seinen drei Knöpfen — je 44 × 44 px, damit am Telefon kein Daumen das Nachbarfoto
 * trifft. Entfernen fragt nicht nach, darum trägt es die Warnfarbe und nennt die Nummer.
 */
export function ResourceImageTile(props: Props) {
  const icon = 'min-h-11 min-w-11';
  return (
    <li className="space-y-1">
      <ResourceImageThumb
        groupId={props.groupId}
        resourceId={props.resourceId}
        imageId={props.imageId}
      />
      <div className="flex items-center justify-between">
        <div className="flex">
          <Button
            type="button"
            size="sm"
            variant="ghost"
            className={icon}
            aria-label={`Foto ${props.number} nach vorn`}
            disabled={props.first || props.busy}
            onClick={() => props.onMove('Up')}
          >
            <ArrowLeft size={14} strokeWidth={2} />
          </Button>
          <Button
            type="button"
            size="sm"
            variant="ghost"
            className={icon}
            aria-label={`Foto ${props.number} nach hinten`}
            disabled={props.last || props.busy}
            onClick={() => props.onMove('Down')}
          >
            <ArrowRight size={14} strokeWidth={2} />
          </Button>
        </div>
        <Button
          type="button"
          size="sm"
          variant="ghost"
          className={`${icon} text-sealwax`}
          aria-label={`Foto ${props.number} entfernen`}
          disabled={props.busy}
          onClick={props.onRemove}
        >
          <Trash2 size={14} strokeWidth={2} />
        </Button>
      </div>
    </li>
  );
}
